var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCancelWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b,.c{fill:none;}.b{stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.75px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-52 -509)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    rx: 12,
    transform: "translate(52 509)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49 509)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 6,
    y2: 6,
    transform: "translate(12 9)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 6,
    y2: 6,
    transform: "translate(12 9)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 24,
    height: 24,
    transform: "translate(52 509)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancelWhite);
export default __webpack_public_path__ + "static/media/Icon_Cancel_White.2bf209a64757df51a3f9e9ac9f1fa77c.svg";
export { ForwardRef as ReactComponent };